import React, { Component } from 'react';
import Dotdotdot from 'react-dotdotdot'
import {Link} from 'react-router-dom'

class NewsCard extends Component {
    render() {
        const {id,cover, title, created, detail, short_description } = this.props.news
        return (
            <div className="news-card-wrap is-100 is-md-100 is-sm-100">
                <div className="news-card is-sm-row">
                    <div className="news-image-wrap gapr-24 md-gapr-0">
                        <img src={cover} alt="News"/>
                    </div>
                    <div className="news-detail-wrap">
                        <Link className="news-topic" to={`/news/${id}`}>
                            <Dotdotdot clamp={2}>{title}</Dotdotdot>
                        </Link>
                        <div className="news-date gapb-8">{created}</div>
                        <Dotdotdot clamp={1} className="news-detail">
                            <div>{short_description}</div>
                        </Dotdotdot>
                    </div>
                </div>
            </div>
        );
    }
}

export default NewsCard;
